import React from "react";
import PopoverField from "./PopoverField";
import "./styles/PopoverField.css";

/**
 * DateRangeFilter - From/to date inputs in a filter popover.
 * @param {Object} props
 * @param {string} props.label - Filter label
 * @param {string} props.fromValue - Start date value
 * @param {string} props.toValue - End date value
 * @param {Function} props.onFromChange - Change handler for the start date
 * @param {Function} props.onToChange - Change handler for the end date
 * @param {string} props.align - 'left' (default) or 'right' panel alignment
 */
const DateRangeFilter = ({
  label,
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  align,
}) => {
  return (
    <PopoverField
      label={label}
      align={align}
      active={Boolean(fromValue || toValue)}
    >
      <div className="dsRangeRow">
        <input
          type="date"
          className="dsRangeInput"
          aria-label={`${label} from`}
          value={fromValue}
          onChange={onFromChange}
        />
        <span className="dsRangeSeparator">to</span>
        <input
          type="date"
          className="dsRangeInput"
          aria-label={`${label} to`}
          value={toValue}
          onChange={onToChange}
        />
      </div>
    </PopoverField>
  );
};

export default DateRangeFilter;
